import React, { useContext } from 'react';
import { Button, FormControl, makeStyles } from '@material-ui/core';
import { PropTypes } from 'prop-types';
import MessagesContext from '../../../contexts/messagesContext';
import LanguageContext from '../../../contexts/languageContext';
const styles = makeStyles((theme) => ({
    rootFormControl: (props) => ({
        direction: props.dynamic ? 'ltr' : 'inherit',
        textAlign: props.dynamic ? 'left' : 'inherit',
        paddingLeft: props.isGender ? '0' : props.width === '100%' || !props.rtl ? '0' : '30px',
        paddingRight: props.isGender ? '0' : !props.rtl ? '30px' : '0',
        paddingBottom: '26px',
        [theme.breakpoints.down(1025)]: {
            paddingLeft: 0,
            paddingRight: 0
        }
    }),
    label: {
        paddingBottom: '8px',
        color: '#767676'
    },
    container: {
        display: 'flex'
    },
    item: (props) => ({
        fontFamily: 'inherit',
        fontSize: '14px',
        backgroundColor: 'white',
        color: '#3d454a',
        minWidth: !props.isGender && '100px',
        width: props.isGender && '100%',
        minHeight: '40px',
        // height: '100%',
        borderRadius: '0',
        borderTop: 'solid 1px #bbbbbb',
        borderBottom: 'solid 1px #bbbbbb',
        borderRight: 'solid 1px #bbbbbb',
        borderLeft: 'none',
        [theme.breakpoints.down(1025)]: {
            flex: 1,
            minWidth: '50px'
        },
        [theme.breakpoints.down(350)]: {
            flex: 1,
            minWidth: '40px',
            lineHeight: '1.5'
        },
        '&:first-child': {
            // borderRadius: props.rtl && '0px 4px  4px 0px',

            borderTopRightRadius: props.rtl ? '4px' : '0',
            borderBottomRightRadius: props.rtl ? '4px' : '0',
            borderTopLeftRadius: props.rtl ? '0' : '4px',
            borderBottomLeftRadius: props.rtl ? '0' : '4px',
            borderLeft: !props.rtl ? 'solid 1px #bbbbbb' : 'none'
        },
        '&:last-child': {
            // borderRadius: props.rtl && '4px 0px 0px 4px',

            borderTopLeftRadius: props.rtl ? '4px' : '0',
            borderBottomLeftRadius: props.rtl ? '4px' : '0',
            borderTopRightRadius: props.rtl ? '0' : '4px',
            borderBottomRightRadius: props.rtl ? '0' : '4px',
            borderLeft: props.rtl ? 'solid 1px #bbbbbb' : 'none'
        },
        '&:hover': {
            backgroundColor: '#1b90fa',
            color: 'white'
        },
        '&:disabled': {
            opacity: '0.5',
            cursor: 'not-allowed',
            pointerEvents: 'all !important',
            color: '#3d454a'
        },
        '&[disabled]:hover': {
            color: '#3d454a',
            opacity: '0.5'
        }
    }),
    active: {
        backgroundColor: '#1b90fa !important',
        color: 'white !important',
        '&:disabled': {
            backgroundColor: '#b0b3b8 !important'
        }
    }
}));
export default function FlatSelect({
    options,
    selected,
    handleSelect,
    label,
    optionalToUse,
    name,
    id,
    isGender,
    disabled = false,
    ...props
}) {
    const { messages } = useContext(MessagesContext);
    const { lang } = useContext(LanguageContext);
    const classes = styles({ ...props, rtl: lang === 'fa', isGender });
    return (
        <FormControl classes={{ root: classes.rootFormControl }}>
            {label && (
                <label className={classes.label} htmlFor={id || name} id={id}>
                    {label}
                    {optionalToUse && (
                        <span style={{ color: '#bbbbbb' }}> ({messages.optional}) </span>
                    )}
                </label>
            )}

            <div className={classes.container} aria-labelledby={id}>
                {options?.map((option) => (
                    <Button
                        key={option.value}
                        disabled={disabled}
                        className={
                            option.value === selected
                                ? `${classes.active} ${classes.item}`
                                : `${classes.item}`
                        }
                        onClick={() => handleSelect(option.value)}
                    >
                        {messages[option.label]}
                    </Button>
                ))}
            </div>
        </FormControl>
    );
}
FlatSelect.propTypes = {
    options: PropTypes.array,
    selected: PropTypes.string,
    handleSelect: PropTypes.func,
    label: PropTypes.string,
    name: PropTypes.string,
    id: PropTypes.number,
    optionalToUse: PropTypes.bool,
    isGender: PropTypes.bool,
    field: PropTypes.object,
    disabled: PropTypes.bool
};
